import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";
import { ESTADOS } from "../../constants";

/**
 * Badge para estados de incidencias
 */
const EstadoBadge = ({ estado, label }) => {
  const getColorByEstado = (estado) => {
    switch (Number(estado)) {
      case ESTADOS.ABIERTA:
        return BADGE_COLORS.BLUE; // Abierto - Azul
      case ESTADOS.EN_REVISION:
        return BADGE_COLORS.AMBER; // En Revisión - Ámbar (proceso)
      case ESTADOS.CERRADA:
        return BADGE_COLORS.GREEN; // Cerrado - Verde (completado)
      default:
        return BADGE_COLORS.GRAY;
    }
  };

  const color = getColorByEstado(estado);

  return (
    <Chip
      label={label}
      size="small"
      sx={getBadgeStyles(color)}
    />
  );
};

export default EstadoBadge;
